<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="スカウト・いいね＿一覧画面の表示情報の設定"
      />
      <div class="boss-selection-container clearfix">
        <div class="boss-selection-wrap">
          <div class="boss-selection-resume-left">
            <span class="boss-userid-text boss-position-reset">ID:サンプル</span>
            <div class="boss-resumecard-item-left-item">
              <div class="boss-avatar">
                <img
                  class="boss-avatar-image"
                  src="../../../assets/images/boss-avatar.svg"
                  alt="90日以上無し"
                >
              </div>
              <div class="boss-latest-action">
                <div class="boss-resumecard-head">
                  最終ログイン
                </div>
                <div class="boss-resumecard-date">
                  -
                </div>
              </div>
              <div class="boss-another-scout">
                <div class="boss-resumecard-head">
                  他社からのスカウト
                </div>
                <div class="boss-resumecard-date">
                  -
                </div>
              </div>
            </div>
          </div>
          <div class="boss-selection-resume-right">
            <div class="boss-select-title">
              <span class="boss-select-text">標準項目</span>
              <span class="boss-select-text">年齢・性別・現住所・就業状況・現在（直近）の年収・転職回数・直近の経験職種・希望職種・希望勤務地・希望年収</span>
            </div>
            <ul
              class="boss-select-list-resume pega-clear-padding"
              data-test="selected-item"
            >
              <div
                v-if="isDragging"
                class="pega-drop-area top"
                data-test="drop-area"
              >
                <p>↓ この範囲に要素をドラッグしてください</p>
              </div>
              <draggable
                v-model="selectedItems"
                class="pega-drag-area"
                group="items"
                data-test="draggable-selected"
                @start="changeDragging"
                @end="changeDragging"
              >
                <li
                  v-for="item in selectedItems"
                  :key="item.id"
                  class="boss-select-item"
                >
                  <span
                    class="boss-select-item-text"
                    v-html="item.name"
                  />
                </li>
              </draggable>
              <div
                v-if="isDragging"
                class="pega-drop-area bottom"
                data-test="drop-area"
              >
                <p>↑ この範囲に要素をドラッグしてください</p>
              </div>
            </ul>
          </div>
        </div>
        <div class="boss-center-container">
          <div class="boss-arrow" />
        </div>
        <div class="boss-select-container">
          <div class="boss-select-title">
            <span class="boss-select-text">表示したい項目を右枠から左枠にドラッグしてください。</span>
          </div>
          <div class="boss-select-wrap">
            <ul
              class="boss-select-list pega-clear-padding"
              data-test="unselected-item"
            >
              <div
                v-if="isDragging"
                class="pega-drop-area top"
                data-test="drop-area"
              >
                <p>↓ この範囲に要素をドラッグしてください</p>
              </div>
              <draggable
                v-model="unselectedItems"
                class="pega-drag-area"
                group="items"
                data-test="draggable-unselected"
                @start="changeDragging"
                @end="changeDragging"
              >
                <li
                  v-for="item in unselectedItems"
                  :key="item.id"
                  class="boss-select-item"
                >
                  <span
                    class="boss-select-item-text"
                    v-html="item.name"
                  />
                </li>
              </draggable>
              <div
                v-if="isDragging"
                class="pega-drop-area bottom"
                data-test="drop-area"
              >
                <p>↑ この範囲に要素をドラッグしてください</p>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div class="boss-button-container">
        <button
          class="boss-button boss-button-return"
          data-test="back"
          @click="$router.back()"
        >
          <span
            class="boss-button-return-text"
          >戻る</span>
        </button>
        <button
          class="boss-button boss-button-confirm"
          data-test="update-button"
          @click="updateDisplayItems"
        >
          <span class="boss-button-confirm-text">登録する</span>
        </button>
      </div>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import draggable from 'vuedraggable'
import SettingHeader from '@/components/atoms/SettingHeader'
import _ from 'lodash'

export default {
  components: {
    draggable,
    SettingHeader
  },
  data () {
    return {
      unselectedItems: [],
      selectedItems: [],
      isDragging: false
    }
  },
  created () {
    this.fetchDisplayItems()
  },
  methods: {
    fetchDisplayItems () {
      this.$http.secured.get('/company/settings/scout/display_items').then(response => {
        this.$set(this, 'selectedItems', _.get(response.data, 'selectedItems', []))
        this.$set(this, 'unselectedItems', _.get(response.data, 'unselectedItems', []))
      })
    },
    updateDisplayItems () {
      this.$http.secured.put('/company/settings/scout/display_items', _.map(this.selectedItems, 'id')).then(response => {
        this.$toasted.global.success({ message: '表示項目を更新しました。' })
      })
    },
    changeDragging () {
      this.isDragging = !this.isDragging
    }
  }
}
</script>
